/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import GridTable from "@nadavshaar/react-grid-table";
import { confirmAlert } from "react-confirm-alert";

class Projects extends Component {
  state = {
    data: {
      projectName: "",
      client: "",
      status: "",
      projectManager: "",
      startDate: "",
      dueDate: "",
      closeDate: "",
    },

    contentHeader: "Projects",
    addButtonLabel: "Add Project",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetProjects",
    singleItemUrl: "/api/data/GetProject",
    addUrl: "/api/data/AddProject",
    editUrl: "/api/data/EditProject",
    deleteUrl: "/api/data/DeleteProject",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Project",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Project",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "70vw",

    editEntityId: 0,

    allStatus: [],
    allTechnicians: [],

    tableData: [],
    tableColumns: [
      {
        id: 1,
        label: "Project",
        field: "PROJECT_NAME",
      },
      {
        id: 2,
        label: "Clinet",
        field: "CLIENTX",
      },
      {
        id: 3,
        label: "Status",
        field: "STATUSX",
        cellRenderer: ({ data }) => {
          return (
            <span
              style={{
                color: "white",
                backgroundColor: data.STATUS_COLOR,
                "border-radius": "3px",
              }}
            >
              <b>&nbsp;{data.STATUSX}&nbsp;</b>
            </span>
          );
        },
      },
      {
        id: 4,
        label: "Project Manager",
        field: "PROJECT_MANAGER",
      },
      {
        id: 5,
        label: "Start Date",
        field: "START_DATE",
      },
      {
        id: 6,
        label: "Due Date",
        field: "DUE_DATE",
      },
      {
        id: 7,
        label: "Close Date",
        field: "CLOSE_DATE",
      },
      {
        id: 8,
        label: "Insert Date",
        field: "INSERT_DATE",
      },
      {
        id: 9,
        label: "Last Update",
        field: "LAST_UPDATE",
      },
      {
        id: 10,
        label: "Actions",
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB09"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB14"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
              <div className="inner" title="View Project Details">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.handleViewProject(data);
                  }}
                >
                  <i className="fa fa-eye" />
                </button>
              </div>
            </div>
          );
        },
      },
    ],
  };

  handleViewProject(row) {
    window.location.replace("/dashboard/projectview?projectId=" + row.ID);
  }

  handleDelete(row) {
    confirmAlert({
      title: "Delete Project",
      message: "Are you sure to delete this project?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            post(
              this.state.deleteUrl,
              { projectId: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        {
          label: "Cancel",
          onClick: () => null,
        },
      ],
    });
  }

  componentDidMount() {
    this.getData();
    this.getAllStatus();
    this.getAllTechnicians();
  }

  getAllStatus() {
    post(
      "/api/data/GetProjectStatusDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allStatus: apiResponse.data.respData.data,
      });
    });
  }

  getAllTechnicians() {
    post(
      "/api/data/GetTechniciansDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allTechnicians: apiResponse.data.respData.data,
      });
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["projectName"] = apiResponse.data.respData.data[0].PROJECT_NAME;
      data["client"] = apiResponse.data.respData.data[0].CLIENTX;
      data["status"] = apiResponse.data.respData.data[0].STATUSX;
      data["projectManager"] =
        apiResponse.data.respData.data[0].PROJECT_MANAGER;
      data["startDate"] = apiResponse.data.respData.data[0].START_DATE;
      data["dueDate"] = apiResponse.data.respData.data[0].DUE_DATE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["projectId"] = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{this.state.contentHeader}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB08"]) && (
              <Button
                label={this.state.addButtonLabel}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode
                ? this.state.modalHeaderEdit
                : this.state.modalHeaderAdd}
            </h5>
          }
          footer={
            <div>
              <Button
                label={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonLabelEdit
                    : this.state.modalSubmitButtonLabelAdd
                }
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label="Cancel"
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "projectName",
                label: "Project Name",
                disabled: false,
              },
              {
                type: "text",
                id: "client",
                label: "Client",
                disabled: false,
              },
              {
                type: "dropdown",
                id: "status",
                label: "Status",
                options: this.state.allStatus,
                disabled: false,
              },
              {
                type: "dropdown",
                id: "projectManager",
                label: "Project Manager",
                options: this.state.allTechnicians,
                disabled: false,
              },
              {
                type: "datetime",
                id: "startDate",
                label: "Start Date",
                disabled: false,
              },
              {
                type: "datetime",
                id: "dueDate",
                label: "Due Date",
                disabled: false,
              },
              {
                type: "datetime",
                id: "closeDate",
                label: "Close Date",
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <GridTable
          columns={this.state.tableColumns}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 30, 40]}
          texts={{
            search: "Search:",
            totalRows: "Total Rows:",
            rows: "Row:",
            selected: "Selected",
            rowsPerPage: "Rows Per Page:",
            page: "Page:",
            of: "of",
            prev: "Pervious",
            next: "Next",
            columnVisibility: "Column Visibility",
          }}
        />
      </div>
    );
  }
}

export default Projects;
